import {Collapse} from 'antd'
import {useState} from 'react'
import {TargetsviewTableCard} from '../targetsview-table-card'
import {widthLarge} from 'helpers/style'
import {useNavigate} from 'react-router-dom'
import {useDomain} from 'contexts/DomainContext'

const {Panel} = Collapse

const SiteTargets = ({sitesview}) => {
  const [activeKey, setActiveKey] = useState(0) // Controls which panel is open
  const {terms} = useDomain()

  const navigate = useNavigate()
  const handleTargetClick = target => {
    if (target?.id) {
      navigate(`/target/${target.id}`)
    }
  }

  const handleChange = key => {
    // Toggle the panel: if the same key is clicked again, close it
    setActiveKey(activeKey === key ? null : key)
  }

  if (!sitesview) return <></>

  return (
    <Collapse activeKey={activeKey} onChange={handleChange}>
      <Panel header={terms.targets} key="1" className="custom-panel">
        <TargetsviewTableCard
          query={{s_id: sitesview.s_id}}
          width={widthLarge}
          handleTargetClick={handleTargetClick}
          parentLevel={2}
        />
      </Panel>
    </Collapse>
  )
}

export default SiteTargets
